import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import { useHasBrandEngineFeatureFlag } from 'reservations/account/hooks/featureFlags';
import IconLink from 'reservations/base/components/IconLink';
import { formatPhone } from 'reservations/base/helpers/phone';
import { getAddressAndPhoneNumberStyles } from 'reservations/brand/helpers/v1/styles';

type PhoneNumberProps = {
  phoneNumber: string;
  countryCode?: number;
  renderIcon?: boolean;
};

const PhoneNumber = ({
  phoneNumber,
  countryCode = 1,
  renderIcon = true
}: PhoneNumberProps) => {
  const hasBrandEngineFeature = useHasBrandEngineFeatureFlag();

  return (
    <IconLink
      Icon={LocalPhoneIcon}
      dataTestId="location-card-phone-number"
      href={`tel:${countryCode}-${phoneNumber}`}
      iconSx={theme => ({
        color: theme.palette.soy.light,
        fontSize: '14px',
        fontWeight: 400,
        marginLeft: '-2px'
      })}
      linkSx={theme =>
        getAddressAndPhoneNumberStyles(hasBrandEngineFeature, theme)
      }
      spacing="5px"
      renderIcon={hasBrandEngineFeature ? false : renderIcon}
    >
      {formatPhone(phoneNumber)}
    </IconLink>
  );
};

export default PhoneNumber;
